import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DashboardModels} from '../models/dashboard-models';
import {HelperService} from './helper.service';
import {UserAuthenticationService} from './user-authentication.service';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    private reloadDashboardIconsFunc?: () => void;

    constructor(
        private http: HttpClient,
        private userAuthService: UserAuthenticationService,
        private helperService: HelperService
    ) {
    }


    getDashboardObjekte(): Observable<DashboardModels.DashboardObjekt[]> {
        let url = this.helperService.getSwissWebServiceConfig()!.boardUrl;
        let user = this.userAuthService.getCurrentAuthenticatedUser();
        return this.http.get<DashboardModels.DashboardObjekt[]>(
            url +
            '/LastUsedUserObjects?loginname=' +
            user?.loginname,
            this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)
        );
    }

    getDashboardAdressen(): Observable<DashboardModels.DashboardAdresse[]> {
        let url = this.helperService.getSwissWebServiceConfig().boardUrl;
        let user = this.userAuthService.getCurrentAuthenticatedUser();
        return this.http.get<DashboardModels.DashboardAdresse[]>(
            url +
            '/LastUsedUserAddresses?loginname=' +
            user?.loginname,
            this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)
        );
    }

    getDashboardBadgeIcons(): Observable<DashboardModels.DashboardBadgeIcons> {
        let url = this.helperService.getSwissWebServiceConfig()!.boardUrl;
        let user = this.userAuthService.getCurrentAuthenticatedUser();
        return this.http.get<DashboardModels.DashboardBadgeIcons>(
            url + '/BadgeIcons?loginname=' + user?.loginname,
            this.helperService.getSwissHttpOptions(this.userAuthService.currentUserInfo)
        );
    }

    public reloadDashboardBadgeIcons() {
        if (this.reloadDashboardIconsFunc) {
            this.reloadDashboardIconsFunc();
        }
    }

}
